import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import useTableStore from '@/data/store/useTableStore';

const TableCell = ({ children, width, minWidth, index, tableId }) => {
    // Subscribe to only this table/index so cells re-render when its width changes
    const widthFromStore = useTableStore(React.useCallback((s) => s.columnWidths[tableId]?.[index], [tableId, index]));
    const computedWidth = Math.max(widthFromStore || width || minWidth, 150);

    return (
        <View style={styles.cell(computedWidth, minWidth)} > 
            {typeof children === "string" || typeof children === "number" ? <Text style={styles.cellText}>{children}</Text> : children}
        </View>
    );
};

const styles = StyleSheet.create((theme) => ({
    cell: (width, minWidth) => ({
        width: width,
        flex: width ? undefined : 1,
        minWidth: minWidth || undefined,
        paddingVertical: 10,
        paddingHorizontal: 10,
        justifyContent: 'center',
        overflow:"hidden",
    }),
    cellText: {
        fontSize: 14,
        fontFamily: theme.fonts.body,
        color: theme.colors.textSecondary
    }
}));

export default React.memo(TableCell);
